import moment from 'moment-timezone'
export const initialState = {
  zone: moment.tz.guess()
}
